import React from 'react';
import { Button } from '@bringg/react-components';
import './empty-message.scss';
import type { EmptyMessageTranslations } from '../../../../components/routes-planner/translations';

interface EmptyMessageProps {
	translations: EmptyMessageTranslations;
	onContactSupport: () => void;
}

const EmptyMessage: React.FC<EmptyMessageProps> = ({ translations, onContactSupport }) => {
	return (
		<div className="message-container" data-test-id="empty-message">
			<div>{translations.noResults}</div>
			<div>{translations.getInTouch}</div>
			<Button type="primary" onClick={onContactSupport} className="contact-support-btn">
				{translations.contactSupport}
			</Button>
		</div>
	);
};

export default EmptyMessage;
